import { createGlobalStyle } from "styled-components";

export const GlassmorphismToastStyles = createGlobalStyle`
  .glassmorphism-toast-wrapper {
    --toastify-toast-width: 30rem !important;
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 1rem !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width: min(30rem, 100%) !important;
    max-width: 30rem !important;
    min-width: 0 !important;
    display: flex !important;
    justify-content: center !important;
    width: 30rem !important;
    max-width: 30rem !important;
  }

  @media (max-width: 480px) {
    .glassmorphism-toast-wrapper {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 1rem !important;
    }
  }

  .glassmorphism-toast-wrapper .Toastify__toast-body {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }

  /* Keep progress bar in DOM for autoClose animation, but hide visually */
  .glassmorphism-toast-wrapper .Toastify__progress-bar {
    height: 0;
    opacity: 0;
  }
`;
